import axios from 'axios';

// Base API URL
 //const baseURL = 'http://localhost:8808/v1/api';
const baseURL='https://aeplserver.thetutorlancer.com/v1/api';

// Create an Axios instance
export const axiosClient = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    'x-client-deviceid': process.env.REACT_APP_DEVICE_ID || 'web-client', // fallback if env is missing
  },
});

// Request interceptor to dynamically inject latest auth token
axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers['x-auth-token'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Optional: a separate header object (if needed for fetch or non-Axios usage)
export const headerKey = {
  'Content-Type': 'application/json',
  'x-auth-token': `Bearer ${localStorage.getItem('authToken') || ''}`,
  'x-client-deviceid': process.env.REACT_APP_DEVICE_ID || 'web-client',
};
